"use strict";require("./_object-sap")("getOwnPropertyNames",function(){return require("./_object-gopn-ext").f});